import { EXTERNAL_CREATE_SESSION_SUCCESS } from '../constants/actionTypes'

export const externalCreateSessionSuccess = result => ({
  type: EXTERNAL_CREATE_SESSION_SUCCESS,
  payload: {
    ...result,
  },
})
